module.exports = __webpack_public_path__ + "img/partner2.8f4eb087.png";